/**
 * index.tsx
 *
 * Author: Maurice T. Meyer
 * E-Mail: maurice@lavireo.com
 *
 * (c) Laviréo. All rights reserved.
 *
 * This document is the property of Laviréo.
 * It is considered confidential and proprietary.
 *
 * This document may not be reproduced or transmitted in any form,
 * in whole or in part, without the express written permission of
 * Laviréo.
 */

import { FC, useId, useMemo } from 'react';
import { styles }             from './styles';
import { useConfig }          from '~/hooks/useConfig';
import { Option } from './option';

export const ExtrasForm: FC = () => {
  const childId     = useId();
  const { options } = useConfig();

  const children = useMemo(() => options.map((option: string) => {
    const [label, value] = option.split(':');
    return <Option name="extras" key={`${childId}-${value}`} label={label} value={value} />;
  }), [options]);

  return (
    <div css={styles.container}>
      {children}
    </div>
  );
};
